import React, { useContext, useEffect, useState } from "react";
import InputField from "@components/inputField";
import ChevronDown from "@public/images/icons/chevron-down.svg";
import { useDispatch, useSelector } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import { Context } from "@components/useContext/context";
import NcbBottomSheet from "@components/NcbBottomSheet";

interface NcbInputFieldProps {
  value?: string;
  handleInputClick: (id: string) => void;
  id: string;
  [key: string]: any;
}

const NcbInputField: React.FC<NcbInputFieldProps> = ({
  value,
  handleInputClick,
  inputId,
  ...props
}) => {
  const dispatch = useDispatch();
  const { isDesktop } = useContext(Context);
  const [inputValue, setInputValue] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);

  const { note } = props;
  const { prevNcb } = useSelector(({ globalState }: any) => {
    return {
      prevNcb: globalState?.prevNcb || null
    };
  });

  useEffect(() => {
    // getting value from inputState using the provided id ("make, "model" .. etc)
    console.log("lol", prevNcb);
  }, [inputId, value]);
  console.log("lol", prevNcb);
  const inputHandleClick = () => {
    // console.log("lol heheh");
    dispatch(
      setPayloadData({
        prevNcb: "50% xoxo"
      })
    );
    setShowModal(true);
    // handleInputClick(inputId);
  };

  return (
    <>
      <InputField
        touched={undefined}
        errors={undefined}
        placeholder={""}
        name={""}
        isDesktop={""}
        readOnly={true} // setting input field as read-only
        handleClick={inputHandleClick}
        Icon={ChevronDown}
        value={inputValue}
        inputContainerStyles={`width: 80%; margin-top: 0; right: ${isDesktop ? "2rem" : "1rem"}`}
        note={note}
        {...props}
      />
      <NcbBottomSheet showModal={showModal} setShowModal={setShowModal} {...props} />
    </>
  );
};

export default NcbInputField;
